import { render } from "./SearchTypes.vue?vue&type=template&id=a1ad4672"
import script from "./SearchTypes.vue?vue&type=script&lang=js"
export * from "./SearchTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__